import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './Services.css';

const Services = () => {
  useScrollAnimation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const services = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="3" y1="9" x2="21" y2="9"></line>
          <line x1="9" y1="21" x2="9" y2="9"></line>
        </svg>
      ),
      title: "Création de Sites Web",
      description: "Sites vitrines, e-commerce et plateformes sur mesure, optimisés pour la performance et le référencement. Nous créons des expériences digitales qui convertissent vos visiteurs en clients.",
      category: "DÉVELOPPEMENT WEB"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect>
          <line x1="12" y1="18" x2="12.01" y2="18"></line>
        </svg>
      ),
      title: "Applications Mobiles",
      description: "Applications natives iOS & Android qui offrent une expérience utilisateur fluide et engageante. Développement sur mesure pour répondre à vos besoins spécifiques.",
      category: "MOBILE"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
          <line x1="12" y1="22.08" x2="12" y2="12"></line>
        </svg>
      ),
      title: "E-commerce",
      description: "Plateformes de vente en ligne complètes avec gestion des commandes, paiements sécurisés et inventaire. Solutions e-commerce performantes pour développer votre activité en ligne.",
      category: "E-COMMERCE"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z"></path>
          <path d="M2 17l10 5 10-5"></path>
          <path d="M2 12l10 5 10-5"></path>
        </svg>
      ),
      title: "Design UI/UX",
      description: "Interfaces utilisateur modernes et intuitives qui améliorent l'expérience et l'engagement. Design centré utilisateur pour maximiser la conversion et la satisfaction.",
      category: "DESIGN"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="3"></circle>
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
        </svg>
      ),
      title: "Maintenance & Support",
      description: "Assurez la pérennité et la sécurité de vos plateformes digitales grâce à notre support technique réactif. Maintenance proactive et résolution rapide des problèmes.",
      category: "SUPPORT"
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      ),
      title: "Consulting Digital",
      description: "Conseils stratégiques pour optimiser votre présence digitale et maximiser votre retour sur investissement. Accompagnement personnalisé pour votre transformation digitale.",
      category: "CONSULTING"
    }
  ];

  return (
    <main className="services-page">
      {/* Hero Section */}
      <section className="services-hero section-transition">
        <div className="services-hero-bg" style={{ backgroundImage: `url(/IMG3.jpg)` }}></div>
        <div className="container">
          <div className="services-hero-content">
            <h1 className="services-hero-title">Nos Services</h1>
            <p className="services-hero-subtitle">Solutions Digitales Complètes pour Votre Réussite</p>
            <p className="services-hero-text">
              Chez <b>Cybernex Services</b>, nous transformons vos idées en solutions digitales performantes.
            </p>
            <Link to="/contact" className="services-hero-cta">
              Prendre rendez-vous
            </Link>
          </div>
        </div>
      </section>

      {/* Services Grid Section */}
      <section className="services-grid-section section-transition">
        <div className="services-grid-bg" style={{ backgroundImage: `url(/IMG4.jpg)` }}></div>
        <div className="container">
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-item fade-in">
                <div className="service-item-icon">{service.icon}</div>
                <div className="service-item-category">{service.category}</div>
                <h3 className="service-item-title">{service.title}</h3>
                <p className="service-item-description">{service.description}</p>
                <Link to="/contact" className="service-item-link">
                  En savoir plus
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="services-cta section-transition">
        <div className="container">
          <div className="services-cta-content">
            <div className="services-cta-text">
              <h2 className="services-cta-title">Prêt à Démarrer Votre Projet ?</h2>
              <p className="services-cta-description">
                Planifiez une consultation virtuelle ou en présentiel dès aujourd'hui. 
                Notre équipe est prête à transformer vos idées en réalité digitale.
              </p>
            </div>
            <Link to="/contact" className="services-cta-button">
              Prendre rendez-vous
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Services;
